// extracted by mini-css-extract-plugin
export var tooltip = "Tooltip-module--tooltip--6e7f1";